import {
  AloftToolkitBlob,
  REQUEST_ID_HEADER,
  REQUEST_SESSION_ID_HEADER,
  randomUUID,
} from '@aloft/toolkit-shared';

import { getBaseUrl } from './getBaseUrl.js';
import { ToolkitContext } from './toolkitContext.js';

/**
 * A fetch wrapper for uploading a file to the blob storage endpoint.
 *
 * @param data A file or blob to upload to the storage endpoint
 * @param name A name for the file
 * @param toolkitContext The authorization context for the request
 * @returns a toolkit object representing the uploaded file & metadata
 */
export async function uploadBlob(
  data: File | Blob,
  name: string,
  { fetcherOptions }: ToolkitContext,
): Promise<AloftToolkitBlob.Type> {
  const body = new FormData();
  body.append('data', data, name);

  const headers = new Headers();
  const accessToken = await fetcherOptions.accessTokenFn?.();
  headers.append('Authorization', `Bearer ${accessToken}`);
  headers.append(REQUEST_ID_HEADER, randomUUID());
  headers.append(
    REQUEST_SESSION_ID_HEADER,
    fetcherOptions.headers?.[REQUEST_SESSION_ID_HEADER] ?? '',
  );

  const res = await fetch(`${getBaseUrl()}/api/v1/blobs`, {
    method: 'PUT',
    headers,
    body,
  });

  if (!res.ok) {
    throw new Error(`upload ${name}: ${res.status} ${res.statusText}`);
  }

  const { blob } = await res.json();

  return blob;
}
